<template>
  <div :class="`p-3 br8 ${noOptions ? 'border-line' : 'shadow'}`">
    <!-- :style="{ flex: 2 }" -->
    <div class="d-flex align-items-center" v-if="!noOptions">
      <font-awesome-icon :icon="['fas', 'pen']" class="cp mr-1 ml-auto" :style="{ color: getPrimary300Color() }" @click="handleEdit" />
      <font-awesome-icon :icon="['fas', 'trash']" class="cp ml-4 error300" @click="handleDelete" />
    </div>
    <img v-if="displayData.img.length" :src="displayData.img[0].resized_images ? displayData.img[0].resized_images.dov1280x720 : displayData.img[0].url" alt="image" class="mt-3" />
    <p class="mb-0 gray900 fw700 font18 mt-3" :style="{ 'word-wrap': 'break-word' }">{{ displayData.subject }}</p>
    <p class="des mb-0 gray600 font16 mt-2" v-if="seeMore" :style="{ 'word-wrap': 'break-word' }">{{ displayData.des }}</p>
    <p class="des mb-0 gray600 font16 mt-2" v-if="!seeMore" :style="{ 'word-wrap': 'break-word' }">{{ displayData.des.substring(0, 300) + "..." }}</p>
    <p class="mb-0 gray400 font14 mt-2 cp" @click="() => (seeMore = true)" v-if="!seeMore">see more</p>
    <a v-if="noOptions && displayData.link" class="bg-gray200 br6 p1224 fw700 gray600 mt-3 font14 ml-auto" :href="getLink" target="_blank">View press release</a>
  </div>
</template>

<script>
export default {
  name: "NewPressReleaseData",
  props: { displayData: Object, handleEdit: Function, handleDelete: Function, noOptions: Boolean },
  data() {
    return { seeMore: null }
  },
  mounted() {
    if (this.displayData.des.length > 300) {
      this.seeMore = false
    } else {
      this.seeMore = true
    }
  },
  computed: {
    getLink() {
      // return this.displayData.link
      if (this.displayData.link.startsWith("http")) {
        return this.displayData.link
      } else {
        return "http://" + this.displayData.link
        // return "//" + this.displayData.link
      }
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  display: inline-block;
}
img {
  width: 100%;
  // max-width: 507px;
  max-height: 278px;
  background-size: contain;
  object-fit: contain;
  background: white;
}
.border-line {
  border: 1px solid #e2e8f0;
}
.des {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/data/PressRelease.vue